module.exports = __webpack_public_path__ + "img/product3.f62547f2.png";